import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import * as z from 'zod'
import { useNavigate } from '@tanstack/react-router'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Form, FormControl, FormField, FormItem } from '@/components/ui/form'
import { useAuth } from '@/contexts/AuthContext'

import logoImg from '../assets/logo.svg';
import loginBg from '../assets/login-bg.svg';

const loginSchema = z.object({
    email: z.string().min(1),
    password: z.string().min(1),
})

type LoginForm = z.infer<typeof loginSchema>

export function Login() {
  const navigate = useNavigate()
  const { login } = useAuth()
  const [isLoginError, setIsLoginError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const form = useForm<LoginForm>({
    resolver: zodResolver(loginSchema),
    defaultValues: {
      email: '',
      password: '',
    },
  })

  const onSubmit = async (data: LoginForm) => {
  setIsLoading(true)
  setIsLoginError(false)
  try {
      await login(data.email, data.password)
  } catch (err) {
      setIsLoginError(true)
  } finally {
      setIsLoading(false)
    }
    }

    return (
    <div className="flex flex-col items-center pt-[120px] px-[60px] pb-[240px] gap-[100px] w-full min-h-screen bg-cover bg-center bg-no-repeat box-border relative isolate" style={{ backgroundImage: `url(${loginBg})` }}>
        <img src={logoImg} alt="Logo" className="w-[172.71px] h-[100px] object-contain z-0 flex-none" />
        <div className="flex flex-col justify-center items-center p-8 gap-8 relative w-[414px] min-h-[344px] bg-white shadow-[0px_4px_4px_rgba(0,0,0,0.25)] rounded-[20px] z-[1]">
        <h1 className="w-[350px] h-14 font-medium text-[40px] leading-[56px] text-center text-[#D91F27] font-['Brandon_Grotesque','Work_Sans',sans-serif]">Welcome</h1>

        <Form {...form}>
            <form onSubmit={form.handleSubmit(onSubmit)} className="flex flex-col items-start gap-8 w-[350px]">
            {(isLoginError || form.formState.errors.email || form.formState.errors.password) && (
                <div className="mx-auto w-[350px] h-[22px] text-base text-center text-[#D91F27]">Invalid Username or Password</div>
            )}

            <div className="flex flex-col items-start gap-8 w-[350px]">
                <FormField
                control={form.control}
                name="email"
              render={({ field }) => (
              <FormItem>
              <FormControl>
                        <Input 
                        className="w-[350px] h-10 bg-white border border-[#999999] rounded px-[10px] text-base text-[#242424] placeholder:text-[#999999] placeholder:font-normal"
                        placeholder="Enter Username" 
                        {...field} 
                        />
                </FormControl>
                </FormItem>
                )}
                />

              <FormField
              control={form.control}
              name="password"
              render={({ field }) => (
                <FormItem>
                <FormControl>
                        <Input 
                        type="password" 
                        className="w-[350px] h-10 bg-white border border-[#999999] rounded px-[10px] text-base text-[#242424] placeholder:text-[#999999] placeholder:font-normal"
                        placeholder="Enter Password" 
                        {...field} 
                        />
                </FormControl>
                </FormItem>
                )}
                />
            </div>

            <Button type="submit" disabled={isLoading} className="flex justify-center items-center px-4 py-2 gap-[6px] w-[350px] h-10 bg-[#D91F27] rounded text-white font-medium text-base hover:bg-[#b81a21]">
                {isLoading ? 'Signing in...' : 'Log In'}
            </Button>
            </form>
        </Form>

      </div>
    </div>
  )
}
